"use client";
import * as React from "react";
import MainMenu from "./MainMenu";
import SecondaryMenu from "./SecondaryMenu";
import { useMenus } from "@pulsex/hooks";
import { MENU_KEYS } from "@/constants";
import pulseConfig from "@/pulsex.config";

export default function Menu({isMobile}) {
    const { menus, isLoading } = useMenus(pulseConfig);

    if (isLoading) return;
    return (
        <>
            <MainMenu isMobile={isMobile} items={menus?.getMenuByKey(MENU_KEYS.MAIN)} regionsMenu={menus?.getMenuByKey(MENU_KEYS.REGIONS)}/>
            <SecondaryMenu items={menus?.getMenuByKey(MENU_KEYS.REGIONS) as any} />
        </>
    );
}
